import {
  CENTRE,
  SLUG,
  ID,
  CATEGORY,
  LEGACYIDENTIFIER,
  STORE_CAT,
  STORE_SUBCAT,
  ENTRYID,
} from '../paths'

export const buildRouteFromPath = (
  path,
  {
    centre = '',
    id = '',
    slug = '',
    category = '',
    legacyId = '',
    entryId = '',
    storeCat = '',
    storeSubCat = '',
  }
) =>
  path
    .replace(`:${CENTRE}`, centre)
    .replace(`:${STORE_CAT}`, storeCat)
    .replace(`:${STORE_SUBCAT}`, storeSubCat)
    .replace(`:${ID}`, id)
    .replace(`:${SLUG}?`, slug)
    .replace(`:${SLUG}`, slug)
    .replace(`:${CATEGORY}?`, category)
    .replace(`:${LEGACYIDENTIFIER}?`, legacyId)
    .replace(`:${ENTRYID}?`, entryId)
    .replace(/\/+$/, '') // strip and end slashes
